"use client";

import React from "react";

type RenewalEditPolicyExtrasHeaderType = {
  policyExtrasHeaderTitle: string;
  policyExtrasHeaderDescription: string;
};

function RenewalEditPolicyExtrasHeader({
  policyExtrasHeaderTitle,
  policyExtrasHeaderDescription,
}: RenewalEditPolicyExtrasHeaderType) {
  return (
    <div className="h-fit bg-dark-surface-accent-1-primary rounded-radius-xxl flex flex-col justify-start items-center self-stretch md:pb-spacing-xxl lg:pt-spacing-l md:pt-spacing-xl pb-spacing-l px-spacing-l pt-spacing-xs md:px-0">
      <div className="flex flex-col justify-start items-center lg:max-w-[774px] md:max-w-[432px] max-w-[264px] text-surface-neutral-option-1 ">
        <h1 className="lg:text-5xl md:text-3xl text-surface-neutral-option-1 lg:leading-[45px] md:leading-custom-size-xl text-xl leading-custom-size-l/xl font-header-font whitespace-break-spaces text-center">
          {policyExtrasHeaderTitle}
        </h1>
        <p className="font-body-font text-center text-2xs leading-[150%] lg:text-xs font-normal text-surface-accent-1-primary  whitespace-break-spaces md:mt-spacing-xs mt-spacing-m">
          {policyExtrasHeaderDescription}
        </p>
      </div>
    </div>
  );
}

export default RenewalEditPolicyExtrasHeader;
